import React from 'react';
import { ScheduledJobLogDetailsViewStore } from '../stores';
import { setCurrentView } from 'core/utils';
import { ScheduledJobLogDetailsTemplate } from 'themes/modules/alerts/pages';

@setCurrentView((rootStore, componentProps) => new ScheduledJobLogDetailsViewStore(rootStore, componentProps), 'scheduledJobLogDetailsViewStore')
class ScheduledJobLogDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <ScheduledJobLogDetailsTemplate {...this.props} />;
    }
}

export default ScheduledJobLogDetails;
